import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const GitHubIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M8 0.365265C3.58 0.365265 0 3.94526 0 8.36526C0 11.9053 2.29 14.8953 5.47 15.9553C5.87 16.0253 6.02 15.7853 6.02 15.5753C6.02 15.3853 6.01 14.7553 6.01 14.0853C4 14.4553 3.48 13.5953 3.32 13.1453C3.23 12.9153 2.84 12.2053 2.5 12.0153C2.22 11.8653 1.82 11.4953 2.49 11.4853C3.12 11.4753 3.57 12.0653 3.72 12.3053C4.44 13.5153 5.59 13.1753 6.05 12.9653C6.12 12.4453 6.33 12.0953 6.56 11.8953C4.78 11.6953 2.92 11.0053 2.92 7.94526C2.92 7.07526 3.23 6.35526 3.74 5.79526C3.66 5.59526 3.38 4.77526 3.82 3.67526C3.82 3.67526 4.49 3.46527 6.02 4.49527C6.66 4.31526 7.34 4.22526 8.02 4.22526C8.7 4.22526 9.38 4.31526 10.02 4.49527C11.55 3.45527 12.22 3.67526 12.22 3.67526C12.66 4.77526 12.38 5.59526 12.3 5.79526C12.81 6.35526 13.12 7.06526 13.12 7.94526C13.12 11.0153 11.25 11.6953 9.47 11.8953C9.76 12.1453 10.01 12.6253 10.01 13.3753C10.01 14.4453 10 15.3053 10 15.5753C10 15.7853 10.15 16.0353 10.55 15.9553C12.1381 15.4191 13.5182 14.3984 14.4958 13.0369C15.4735 11.6753 15.9996 10.0415 16 8.36526C16 3.94526 12.42 0.365265 8 0.365265Z"
		/>
	</svg>
))
